import styled from "styled-components";

export const Container = styled.div<{ $noMarginTop?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  ${({ $noMarginTop }) => ($noMarginTop ? "margin-top: 0;" : "")}
`;

export const TransactionsTableWrapper = styled.div`
  width: 100%;

  /* Evita que TableContainer force min-height excessivo */
  > div {
    min-height: auto;
    padding-bottom: 0;
  }

  table {
    border-spacing: 0 8px;
    margin-top: 0;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px;
`;

export const DescriptionCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DescriptionTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

export const DescriptionTitle = styled.span<{ $color: string }>`
  font-weight: 600;
  font-size: 15px;
  color: ${({ $color }) => $color};
`;

export const DescriptionMetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--gray);
  font-size: 12px;
`;

export const DescriptionDateGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const MetaText = styled.span``;

export const TypeCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  height: 100%;
`;

export const TypeBadgeRow = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ $color }) => $color};
  font-weight: 600;
  font-size: 13px;
`;

export const TypeLabel = styled.span``;

export const AmountCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  height: 100%;
`;

export const AmountValue = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: var(--black);
  font-size: 14px;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 16px;
  padding-bottom: 8px;
`;
